import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import ServiceTableActions from "./components/table-action";
import SearchField from "../../../../../components/search-field";
import { useAttendanceLocalServiceList } from "../../../../../../../services/api-tansquery/attendance-local/service/list";
import { useAttendanceLocalStyles } from "../../../../../styles";
import { useServiceListTabPanelStyles } from "./styles";
import { useParams } from "react-router-dom";
import EmptyState from "../../../../../../../Components/EmptyState";
import ServiceFormCreate from "../form/create";
import CustomPagination from "../../../../../../../Components/pagination";

export default function ServiceListTabPanel() {
    const { slug } = useParams<{ slug: string }>();
    const { classes } = useServiceListTabPanelStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: services } = useAttendanceLocalServiceList({
        unidade_slug: slug,
    });

    const isEmptyServices = (services?.results ?? []).length === 0;

    return (
        <Paper elevation={3}>
            <Box className={classes.header}>
                <Box className={classes.search}>
                    <SearchField placeholder="Buscar serviço" />
                </Box>
                <ServiceFormCreate slug={slug} />
            </Box>
            <TableContainer className={defaultClasses.tableContainer}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={defaultClasses.tableTH}>Serviço</TableCell>
                            <TableCell className={defaultClasses.tableTH}>
                                Presencial
                            </TableCell>
                            <TableCell className={defaultClasses.tableTH}>Online</TableCell>
                            <TableCell className={defaultClasses.tableTH} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {services?.results.map((service) => (
                            <TableRow
                                hover
                                key={`service-${service.id}`}
                                role="checkbox"
                                tabIndex={-1}
                            >
                                <TableCell className={defaultClasses.tableCell}>
                                    {service.servico.titulo}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    <Box
                                        className={`${defaultClasses.badge} ${service.atendimento
                                            ? defaultClasses.active
                                            : defaultClasses.inactive
                                            }`}
                                    >
                                        {service.atendimento ? "Sim" : "Não"}
                                    </Box>
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    <Box
                                        className={`${defaultClasses.badge} ${service.agendamento
                                            ? defaultClasses.active
                                            : defaultClasses.inactive
                                            }`}
                                    >
                                        {service.agendamento ? "Sim" : "Não"}
                                    </Box>
                                </TableCell>
                                <TableCell align="right" className={defaultClasses.tableCell}>
                                    <ServiceTableActions service={service} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {isEmptyServices && <EmptyState message="Nenhum serviço encontrado" />}
            </TableContainer>
            <Box className={defaultClasses.paginationContainer}>
                <CustomPagination
                    count={services?.count}
                    page={services?.current}
                    totalPages={services?.total_pages}
                />
            </Box>
        </Paper>
    );
}
